import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, ComputedRef, watch, Ref } from 'vue';
import store from '@/store';
import { Roles } from '@/typings/user';
import StoreType from '@/typings/storeType';
import CSelect, { type CSelectItem, valueReducer } from '@/components/shared/CSelect';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersHeaderListPreview',
  setup(__props) {

const canvas = computed(() => store.state.storeLayers?.canvas);

const selectedPreview: Ref<string | undefined> = ref();

const listPreview: ComputedRef<CSelectItem<string>[]> = computed(() => {
    return canvas.value?._listPreview?.map((preview) => ({
        label: preview.name,
        value: `${preview.PreviewId}`,
    })) || [];
});

const isEnabled = computed(() => {
    const user = store.state.user;
    if (!user) return false;

    const roles = user.AccessRoles?.Serialized.split(',');

    const isAdmin = roles?.includes(Roles.ADMIN);
    const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
    const isMultiPreview = roles?.includes(Roles.MULTI_PREVIEW);
    const stores = store.state.user?.Stores || [];
    const multiPreviewStoreTypes = [StoreType.Shopify, StoreType.Etsy, StoreType.TikTok, StoreType.WooCommerce];
    const hasMultiPreviewStore = stores.some((store) => multiPreviewStoreTypes.includes(store.Type));

    return Boolean(isAdmin || impersonatedFromAdminUser || isMultiPreview || hasMultiPreviewStore);
});

const onPreviewSelected = () => {
    if (!canvas.value) return;
    if (!selectedPreview.value) return;
    canvas.value.selectPreview(Number(selectedPreview.value));
};

watch(
    () => canvas.value?._selectedPreview,
    () => {
        selectedPreview.value = canvas.value?._selectedPreview?.PreviewId?.toString();
    }
);

return { __sfc: true,canvas, selectedPreview, listPreview, isEnabled, onPreviewSelected, CSelect, valueReducer }
}

})